import React from 'react'
import { Divider, ListItem, ListItemIcon, ListItemText, Theme, Typography } from '@mui/material'
import createStyles from '@mui/styles/createStyles'
import makeStyles from '@mui/styles/makeStyles'
import List from '@mui/material/List'
import PersonIcon from '@mui/icons-material/Person'
import ExitToAppIcon from '@mui/icons-material/ExitToApp'
import { useAuth } from '../../../../../../context/Auth'
import { useLogout } from '../../../../../../hooks/useLogout'
import { useNavigate } from 'react-router-dom'

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    dividerFullWidth: {
      margin: `5px 0 0 ${theme.spacing(2)}`,
    },
  })
)

export const ProfileDrawerList = () => {
  const auth = useAuth()
  const navigate = useNavigate()
  const classes = useStyles()
  const handleProfile = () => {
    navigate(`/users/${auth?.id}`)
  }
  const handleLogout = useLogout()

  if (auth && auth.id) {
    return (
      <List>
        <Divider component="li" />
        <li>
          <Typography
            className={classes.dividerFullWidth}
            color="textSecondary"
            display="block"
            variant="caption"
          >
            {auth.username}
          </Typography>
        </li>

        <ListItem button onClick={handleProfile}>
          <ListItemIcon>
            <PersonIcon />
          </ListItemIcon>
          <ListItemText primary={'Profil'} />
        </ListItem>
        <ListItem button onClick={() => handleLogout()}>
          <ListItemIcon>
            <ExitToAppIcon />
          </ListItemIcon>
          <ListItemText primary={'Wyloguj'} />
        </ListItem>
      </List>
    )
  }

  return <></>
}
